module.exports = __webpack_public_path__ + "img/st-7.957da4f2.png";